const languages = [
	{ name: 'Assamese', value: 'as-IN' },
	{ name: 'Bengali', value: 'bn-IN' },
	{ name: 'English', value: 'en-IN' },
	{ name: 'Gujarati', value: 'gu-IN' },
	{ name: 'Hindi', value: 'hi-IN' },
	{ name: 'Kannada', value: 'kn-IN' },
	{ name: 'Malayalam', value: 'ml-IN' },
	{ name: 'Marathi', value: 'mr-IN' },
	{ name: 'Odia', value: 'or-IN' },
	{ name: 'Punjabi', value: 'pa-IN' },
	{ name: 'Tamil', value: 'ta-IN' },
	{ name: 'Telugu', value: 'te-IN' },
	{ name: 'Urdu', value: 'ur-IN' },
	{ name: 'Arabic', value: 'ar' },
	{ name: 'Chinese', value: 'zh-Hans' },
	{ name: 'French', value: 'fr' },
	{ name: 'German', value: 'de' },
	{ name: 'Italian', value: 'it' },
	{ name: 'Japanese', value: 'ja' },
	{ name: 'Korean', value: 'ko' },
	{ name: 'Malay', value: 'ms' },
	{ name: 'Persian', value: 'fa' },
	{ name: 'Portuguese', value: 'pt' },
	{ name: 'Russian', value: 'ru' },
	{ name: 'Spanish', value: 'es' },
	{ name: 'Turkish ', value: 'tr' },
	{ name: 'Urdu', value: 'ur' },
	{ name: 'Vietnamese', value: 'vi' },
	{ name: 'Thai', value: 'th' },
	{ name: 'Hebrew', value: 'he' },
	{ name: 'Swedish', value: 'sv' },
	{ name: 'Dutch', value: 'nl' },
]
const Indianlanguages = [
	{ name: 'Assamese', value: 'as-IN' },
	{ name: 'Bengali', value: 'bn-IN' },
	{ name: 'English', value: 'en-IN' },
	{ name: 'Gujarati', value: 'gu-IN' },
	{ name: 'Hindi', value: 'hi-IN' },
	{ name: 'Kannada', value: 'kn-IN' },
	{ name: 'Malayalam', value: 'ml-IN' },
	{ name: 'Marathi', value: 'mr-IN' },

	{ name: 'Punjabi', value: 'pa-IN' },
	{ name: 'Tamil', value: 'ta-IN' },
	{ name: 'Telugu', value: 'te-IN' },
	{ name: 'Urdu', value: 'ur-IN' }


]

export {languages,Indianlanguages};